import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { useTranslation } from 'react-i18next'

import Table from '../Table'

import styles from './ReportDataDisplay.module.scss'

/**
 * ReportDataDisplay component handles the display of report data in table format
 */
export const CallReportDataDisplayView = ({
  isAuthenticated,
  rowsList,
  timeString,
  dispositionMap,
  voteStates,
  onRowClick,
  onUpvote,
  onDownvote,
  currentVote,
  selectedRow,
  drawerOpen,
  onCloseDrawer,
  metrics,
  metricsLoading,
  userId,
  dateRangeStart,
  dateRangeEnd,
  containerWidth,
  isLoading,
  noDataMessage
}) => {
  const { t } = useTranslation()

  if (isLoading) {
    return (
      <Box className={styles.loadingContainer}>
        <Skeleton height={48} />
        <Skeleton count={2} height={24} />
        <br />
        <Skeleton height={48} />
        <Skeleton count={5} height={93} />
        <Skeleton height={48} />
      </Box>
    )
  }

  if (!rowsList || rowsList.length === 0) {
    return (
      <Box className={styles.noDataContainer}>
        <Typography variant='h6'>{t('common.noData')}</Typography>
        <Typography variant='body1'>{noDataMessage || t('metrics.noCallsRecorded')}</Typography>
      </Box>
    )
  }

  return (
    <Table
      isAuthenticated={isAuthenticated}
      rowsList={rowsList}
      timeString={timeString}
      dispositionMap={dispositionMap}
      voteStates={voteStates}
      onRowClick={onRowClick}
      onUpvote={onUpvote}
      onDownvote={onDownvote}
      currentVote={currentVote}
      selectedRow={selectedRow}
      drawerOpen={drawerOpen}
      onCloseDrawer={onCloseDrawer}
      metrics={metrics}
      metricsLoading={metricsLoading}
      userId={userId}
      dateRangeStart={dateRangeStart}
      dateRangeEnd={dateRangeEnd}
      containerWidth={containerWidth}
    />
  )
}

CallReportDataDisplayView.propTypes = {
  isAuthenticated: PropTypes.bool,
  rowsList: PropTypes.array,
  timeString: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dispositionMap: PropTypes.object,
  voteStates: PropTypes.object,
  onRowClick: PropTypes.func,
  onUpvote: PropTypes.func,
  onDownvote: PropTypes.func,
  currentVote: PropTypes.string,
  selectedRow: PropTypes.object,
  drawerOpen: PropTypes.bool,
  onCloseDrawer: PropTypes.func,
  metrics: PropTypes.object,
  metricsLoading: PropTypes.bool,
  userId: PropTypes.string,
  dateRangeStart: PropTypes.object,
  dateRangeEnd: PropTypes.object,
  containerWidth: PropTypes.string,
  isLoading: PropTypes.bool,
  noDataMessage: PropTypes.string
}

export default CallReportDataDisplayView
